import { clsx } from 'clsx';
import type { InputHTMLAttributes } from 'react';

interface CheckboxProps extends InputHTMLAttributes<HTMLInputElement> {
  readonly label?: string;
  readonly description?: string;
  readonly id?: string;
}

export function Checkbox({
  label,
  description,
  id,
  className,
  ...rest
}: CheckboxProps) {
  const checkboxId =
    id || `checkbox-${Math.random().toString(36).substr(2, 9)}`;

  return (
    <div className="flex items-start">
      <div className="flex items-center h-5">
        <input
          id={checkboxId}
          type="checkbox"
          className={clsx(
            'h-4 w-4 rounded border-gray-300 dark:border-gray-600',
            'text-primary focus-visible:ring-primary focus-visible:ring-offset-0 focus-visible:ring-2 focus-visible:ring-offset-transparent',
            'dark:bg-gray-800 dark:checked:bg-primary dark:checked:border-primary',
            'disabled:cursor-not-allowed disabled:opacity-50',
            className,
          )}
          {...rest}
        />
      </div>
      {(label || description) && (
        <div className="ml-3 text-sm">
          {label && (
            <label
              htmlFor={checkboxId}
              className={clsx(
                'font-medium',
                rest.disabled
                  ? 'text-gray-400 dark:text-gray-500'
                  : 'text-gray-700 dark:text-gray-300',
              )}
            >
              {label}
            </label>
          )}
          {description && (
            <p
              className={clsx(
                'text-gray-500 dark:text-gray-400',
                rest.disabled ? 'opacity-50' : '',
              )}
            >
              {description}
            </p>
          )}
        </div>
      )}
    </div>
  );
}
